// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SlotBindingRequest } from './slotBindingRequest';

/**
 * Request to update slot bindings
 */
export interface UpdateSlotBindingsRequest {
  /** New slot binding configurations */
  bindings: SlotBindingRequest[];
}
